module.exports = __webpack_public_path__ + "static/AzoSans-Regular-6c5979f61523fd6910047b517b57eb08.woff";